var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54449 14.5669C-0.542294 12.6829 -0.503401 9.64472 1.59399 7.76754L9.08542 1.06251C10.6681 -0.354109 13.2408 -0.354234 14.8237 1.06251C16.3912 2.46545 16.3931 4.72904 14.8237 6.13363L8.29335 11.9727C7.2271 12.927 5.48503 12.9137 4.43685 11.9416C3.42703 11.005 3.45942 9.52053 4.4887 8.59928L9.62238 4.0107C9.84317 3.81339 10.205 3.81001 10.4305 4.00317L11.2469 4.70251C11.4725 4.8957 11.4763 5.21226 11.2555 5.40957L6.12238 9.99772C5.94624 10.1554 5.93538 10.4173 6.09924 10.5693C6.25538 10.7142 6.50085 10.7166 6.65952 10.5745L13.1898 4.73542C13.8903 4.10848 13.8903 3.08776 13.1895 2.46048C12.5041 1.84714 11.4053 1.84683 10.7197 2.46048L3.22821 9.16547C1.98667 10.2767 1.96753 12.0755 3.18567 13.1752C4.40031 14.2719 6.3637 14.2733 7.5806 13.1842L13.7256 7.68422C13.9462 7.48676 14.308 7.48319 14.5337 7.67622L15.3507 8.3751C15.5764 8.56813 15.5805 8.88469 15.3598 9.08216L9.21485 14.5821C7.08713 16.4864 3.64545 16.4638 1.54449 14.5669Z",
    fill: "#116F9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon_attachment.17506fffcd54101006fda347b2dca8b6.svg";
export { ForwardRef as ReactComponent };